module.exports = __webpack_public_path__ + "img/777.ba67630a.png";